module.exports = __webpack_public_path__ + "img/Chatgpt.18b9334b.png";